import { useState } from 'react';
import { SeasonLink as Link } from "../../components/Seasons/SeasonLink";
import './AuthPage.css';
import { requestPasswordReset } from '../../api/auth';
import { validateEmail } from '../../utils/validators';

export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setMessage('');
    const emailError = validateEmail(email);
    if (emailError) {
      setError(emailError);
      return;
    }

    try {
      setIsSubmitting(true);
      const response = await requestPasswordReset(email.trim());
      setMessage(response?.detail || 'Письмо отправлено.');
    } catch (err) {
      setError(err.message || 'Не удалось отправить письмо.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-form-container" style={{ flex: 1 }}>
        <div className="auth-card">
          <h1 className="auth-title">Восстановление пароля</h1>
          <form className="auth-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label" htmlFor="forgot-email">Email</label>
              <input
                id="forgot-email"
                className="form-input"
                type="email"
                value={email}
                onChange={(event) => setEmail(event.target.value)}
                placeholder="Введите ваш email"
                required
              />
            </div>
            <button type="submit" className="auth-button" disabled={isSubmitting}>
              {isSubmitting ? 'Отправляем...' : 'Отправить ссылку'}
            </button>
          </form>
          {error ? <p className="auth-link" style={{ color: '#cf2f4d' }}>{error}</p> : null}
          {message ? <p className="auth-link">{message}</p> : null}
          <p className="auth-link">
            Вспомнили пароль? <Link to="/login" className="auth-link-register">Войти</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
